import React, { useState } from "react";
import styles from "./CreateUser.module.css";
import { toast } from "react-hot-toast";

const CreateUserModal = ({ onClose }) => {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");

  const handleCreateUser = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/signup`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ email, password }),
        }
      );

      if (response.ok) {
        toast.success("User created successfully!");
        onClose(); // Close the modal
      } else if (response.status === 400) {
        toast.error("Failed to create user, user already exists");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred");
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <button className={styles.closeButtonModal} onClick={onClose}>
          &times;
        </button>
        <h2 style={{ color: "black" }}>Create New User</h2>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={styles.inputBox}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className={styles.inputBox}
        />
        <button onClick={handleCreateUser} className={styles.createButtonModal}>
          Create User
        </button>
      </div>
    </div>
  );
};

export default CreateUserModal;
